import { render, staticRenderFns } from "./InvoiceItem.vue?vue&type=template&id=1492d04e&scoped=true"
import script from "./InvoiceItem.vue?vue&type=script&lang=js"
export * from "./InvoiceItem.vue?vue&type=script&lang=js"
import style0 from "./InvoiceItem.vue?vue&type=style&index=0&id=1492d04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1492d04e",
  null
  
)

export default component.exports